import { collection, getDocs } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { ClipLoader } from 'react-spinners';
import { db } from '../../firebaseFunctions/authhook';
import close from "../../images/close.png";
import TimeFormat from '../Dashboard/TimeFormat';
import "./Close.css"
const Close = () => {
    const timeSchedulingRef = collection(db, "timeScheduling");
    const [timesData, setTimesData] = useState({
        id: '',
        openingTime: '',
        closingTime: ''
    });
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true)
        const getTime = async () => {
            const times = await getDocs(timeSchedulingRef);
            const timesData = times.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
            setTimesData(timesData[0])
            setLoading(false)
        }
        getTime();
    }, [])
    return (
        <div className="closeDesign flex_design">
            {
                loading ?
                    <ClipLoader loading={true} size={50}/>
                    :
                    <>
                        <div className='fail'>
                            <img src={close} alt="" />
                        </div>
                        <br />
                        <p dir="rtl" className="txt_style closeText"> يفتح الحجز الساعة <TimeFormat time={timesData.openingTime}/></p>
                        <br />
                        <p className='txt_style closeText'>ويغلق عند اكتمال العدد (60) شخص</p>
                    </>
            }
        </div>
    );
};

export default Close;
